import { Injectable } from '@angular/core';
import { VERSION_INFO } from './version-info';

/**
 * Servicio para obtener información de versión de la aplicación
 */
@Injectable({
  providedIn: 'root'
})
export class AppVersionService {
  /**
   * Obtiene la versión de la aplicación desde el package.json
   */
  getVersion(): string {
    return VERSION_INFO.version;
  }

  /**
   * Obtiene el hash del commit actual
   */
  getCommitHash(): string {
    return VERSION_INFO.commitHash;
  }

  /**
   * Obtiene la cadena completa de versión
   */
  getFullVersion(): string {
    return `v${this.getVersion()} (${this.getCommitHash()})`;
  }
}
